// extracted by mini-css-extract-plugin
export default {"navContainer":"navbar_navContainer__6hu0f","navIcons":"navbar_navIcons__uw4LO","closedNav":"navbar_closedNav__kVWZQ","slackIcon":"navbar_slackIcon__shLIs"};